import React from 'react'
import Lex from '../Shared/Lex'
import PasswordChange from './PasswordChange'
import MfaSetup from './MfaSetup'

const SecuritySettings = ({ userStore }) => {
  return (
    <div className="security-settings-section">
      <h3><Lex term="security-settings" /></h3>
      
      <div className="security-item">
        <PasswordChange userStore={userStore} />
      </div>
      
      <hr />
      
      <div className="security-item">
        <MfaSetup userStore={userStore} />
      </div>
      
      <style dangerouslySetInnerHTML={{__html: `
        .security-item {
          margin: 30px 0;
        }
        .security-settings-section {
        }
      `}} />
    </div>
  )
}

export default SecuritySettings